<template>
  <div class="d-flex justify-content-end min-vh-100">
    <AnalyzeSideBar
      :questionnaireOptions="getPart"
      :questionnaireId="$route.params.id"
    />
    <div class="body">
      <div class="header">
        <p class="title">{{ title }}</p>
        <p>{{getStatisticsInfo?.title}}</p>
      </div>
      
      <CContainer fluid>
        <div v-for="(info,index) in getStatisticsInfo?.statistics" :key="info.id">
          <div
            class="d-flex col-12 flex-column"
            :class="
              info.type === $defines.ItemTypes.Scale && info.type === $defines.ItemTypes.ColumnInput && info.type === $defines.ItemTypes.DynamicForm
                ? 'border-0'
                : 'border-bottom'
            "
          >
            <div class="d-flex my-3">
              <div
                class="btn-img me-1"
              >
                <img
                  :src="
                    require(`@/assets/icons/${
                      queList?.find((e) => e.type === info.type)?.img
                    }.svg`)
                  "
                />
              </div>
              <div
                class="topic-num text-light me-1"
              >
                {{ displayIndexMap[`${info.title}${index}`] }}
              </div>
              {{ info.title }}
            </div>

            <p
              class="hint px-3"
              v-if="(info.statistics_data.length === 0 && info.type !== $defines.ItemTypes.Scale)"
            >
              此題型無法分析
            </p>
            <div
              class="col-12 d-flex align-items-start justify-content-between"
            >
              <div
                v-if="info.statistics_data.length !== 0"
                class="col-5 ms-5 table-wrapper"
              >
                <AnalyzeTable
                  :statisticsData="info.statistics_data"
                  :questionType="info.type"
                />
              </div>
              <div
                v-if="info.statistics_data.length !== 0"
                class="col-5 me-5 mb-3"
              >
                <AnalyzeChart
                  :statisticsData="info.statistics_data"
                  :questionType="info.type"
                />
              </div>
            </div>
          </div>
        </div>
      </CContainer>
    </div>
    <MsgBox
      :show="showMsgBox"
      :errorCode="errorCode"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>
<script>
import AnalyzeSideBar from '@/components/AnalyzeSideBar.vue'
import AnalyzeChart from '@/components/AnalyzeChart.vue'
import AnalyzeTable from '@/components/AnalyzeTable.vue'
import useQuestionnaire from '@/composables/useQuestionnaire'
import MsgBox from '@/components/MsgBox.vue'
import { useRoute } from 'vue-router'
import { ref } from '@vue/reactivity'
import { computed, onMounted } from '@vue/runtime-core'
import router from '@/router'
import { ItemTypes } from '../defines'

export default {
  components: {
    AnalyzeSideBar,
    AnalyzeTable,
    AnalyzeChart,
    MsgBox,
  },
  setup() {
    const { getReportList } = useQuestionnaire()
    const route = useRoute()
    const getPart = ref([])
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const title = ref('')
    const getList = async () => {
      const res = await getReportList({ id: route.params.id })
      if (!res.error) {
        title.value = res.ret.questionnaire_title
        getPart.value = res.ret.report
        
        if (!getPart.value) {
          showMsgBox.value = true
          errorMsg.value = '此問卷無人發布填答'
          errorCode.value = 'noFill'
        }
      } else {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      }
    }
    const getStatisticsInfo = computed(() => {
      return getPart.value.find((e) => {
        return +e.id === +route.params.part
      })
    })
    onMounted(async () => {
      await getList()
      const id = getPart.value[0].id
      if (id) {
        router.push(`/analyze/${route.params.id}/${id}`)
      }
    })
    const displayIndexMap = computed(() =>
      getStatisticsInfo.value.statistics
        .reduce((accu, cur, i) => {
          if(cur.id){
            if(Math.max(...Object.values(accu)) - 1 === i || Object.values(accu).length === 0){
              accu[`${cur.title}${i}`] = i + 1
            }else{
              accu[`${cur.title}${i}`] = Math.max(...Object.values(accu)) + 1
            }
          }else{
            accu[`${cur.title}${i}`] = Object.values(accu)[Object.values(accu).length-1]
          }
          return accu
        }, {}),
    )
    const queList = ref([
      {
        img: 'text',
        type: ItemTypes.TextItem,
      },
      {
        img: 'radio',
        type: ItemTypes.ChoiceOne,
      },
      {
        img: 'nest',
        type: ItemTypes.Scale,
      },
      {
        img: 'range',
        type: ItemTypes.NumberSlider,
      },
      {
        img: 'textarea',
        type: ItemTypes.TextLong,
      },
      {
        img: 'checkbox',
        type: ItemTypes.ChoiceMultiple,
      },
      {
        img: 'number',
        type: ItemTypes.NumberInput,
      },
      {
        img: 'upload-white',
        type: ItemTypes.UploadFile,
      },
      {
        img: 'stars',
        type: ItemTypes.Score,
      },
      {
        img: 'sort',
        type: ItemTypes.ItemSort,
      },
      {
        img: 'date',
        type: ItemTypes.DateInput,
      },
      {
        img: 'form',
        type: ItemTypes.ColumnInput,
      },
      {
        img: 'introduction',
        type: ItemTypes.Introduction,
      },
      {
        img: 'form',
        type: ItemTypes.DynamicForm,
      },
    ])
    return {
      getList,
      getPart,
      getStatisticsInfo,
      queList,
      showMsgBox,
      errorMsg,
      errorCode,
      displayIndexMap,
      title
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  font-size: 20px;
  font-weight: 500;
  p{
    margin: 0;
  }
  .title{
    font-size: 30px;
    font-weight: 600;
  }
}
.body {
  width: calc(100vw - 255px);
  padding: 0 40px;
}
.btn-img {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #bdbdbd;
  border-radius: 3px;
  left: -2px;
  img {
    width: 15px;
  }
}
.topic-num {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #177baf;
  border-radius: 3px;
  left: -2px;
}
.hint {
  width: 100%;
  height: 50px;
  background: #f3f8fb;
  font-size: 13px;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
}
.table-wrapper {
  font-size: 14px;
}
.change-chart {
  img {
    width: 20px;
  }
}
</style>
